import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsLocaleService, defineLocale } from 'ngx-bootstrap';
import { frLocale } from 'ngx-bootstrap/locale';

@Component({
  selector: 'app-cagnotte-filter',
  templateUrl: './cagnotte-filter.component.html',
  styleUrls: ['./cagnotte-filter.component.css']
})
export class CagnotteFilterComponent implements OnInit {

  @Input() assocsForFilter: any[] = [];

  public dateMaxFrom = new Date();
  public dateMaxTo = new Date();
  public form: FormGroup;
  public statuses = [
    {id: 'OPEN', value: 'Ouverte'},
    {id: 'CLOSED', value: 'Fermée'}
  ];

  constructor(
    public activeModal: NgbActiveModal, 
    private formbuilder: FormBuilder, 
    private localeService: BsLocaleService
  ) {
    const patternEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.form = this.formbuilder.group({
      'email': ['', Validators.pattern(patternEmail)],
      'created_from': ['', Validators.required],
      'created_to': ['', Validators.required],
      'assoc': ['ALL', Validators.required]
    });
    defineLocale(frLocale.abbr, frLocale);
    this.localeService.use('fr');
   }

  ngOnInit() {
  }

  onSubmit() {
    this.validateAllFormFields(this.form);
    this.checkIfStartDateLessThanToDate('created_from', 'created_to');

    if (this.form.valid) {
      console.log('Form valid');
      this.activeModal.close(this.form.value);
    } else {
      console.log('Form not valid');

    }
  }

  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private checkIfStartDateLessThanToDate(fromDateKey: string, toDateKey: string) {
    const fromDateControl = this.form.controls[fromDateKey],
      toDateControl = this.form.controls[toDateKey];
    if (fromDateControl.value > toDateControl.value) {
      fromDateControl.setErrors({greater: true});
    }
    else if (fromDateControl.value=="") {
      fromDateControl.setErrors({invalid: true});
    }
    else {
      fromDateControl.setErrors(null);
    }
  }

}
